import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Settings > Users & Permissions > Lockout Settings (mockup system-settings "Lockout Settings";
 * twin-ci System Settings). Kept as twin-ci: while a PIN is set, saving asks for the original PIN
 * ("Enter Your Pin"), and a new PIN is confirmed there. The API checks the PIN; it is never loaded.
 */
@Component({
    selector: 'app-lockout-settings',
    templateUrl: './lockout-settings.component.html',
    styleUrls: ['./lockout-settings.component.scss']
})
export class LockoutSettingsComponent implements OnInit {
    form: any = null;
    saved: any = null;
    hasPin = false;
    newPin = '';
    removePin = false;
    pinError = '';
    // PIN dialog
    asking = false;
    currentPin = '';
    confirmPin = '';
    dialogError = '';
    loadError = '';
    message = '';
    saving = false;

    constructor(private http: HttpClient) { }

    ngOnInit() {
        this.http.get<any>(environment.api + 'lockout-settings').subscribe(
            res => {
                this.hasPin = res.has_pin;
                this.saved = {
                    lockout_date: res.lockout_date || '',
                    lockout_message: res.lockout_message || '',
                    finding_lockout_message: res.finding_lockout_message || '',
                };
                this.form = Object.assign({}, this.saved);
            },
            err => this.loadError = typeof err === 'string' ? err : 'The lockout settings could not be loaded.'
        );
    }

    get changed() {
        return !!this.newPin || this.removePin
            || ['lockout_date', 'lockout_message', 'finding_lockout_message'].some(k => this.form[k] !== this.saved[k]);
    }

    cancel() {
        this.form = Object.assign({}, this.saved);
        this.newPin = '';
        this.removePin = false;
        this.pinError = this.message = '';
    }

    /** Save Changes: as twin-ci, ask for the PIN(s) first when one is set or being set. */
    save() {
        this.message = '';
        this.pinError = this.newPin && !/^[a-z0-9]+$/.test(this.newPin) ? 'Use lower-case letters and numbers only.' : '';
        if (this.pinError) {
            return;
        }
        if (this.hasPin || this.newPin) {
            this.currentPin = this.confirmPin = this.dialogError = '';
            this.asking = true;
        } else {
            this.send();
        }
    }

    verify() {
        const errors = [];
        if (this.hasPin && !this.currentPin) { errors.push('Invalid Original Pin Code!'); }
        if (this.newPin && this.confirmPin !== this.newPin) { errors.push('Invalid Confirm New Pin Code!'); }
        this.dialogError = errors.join(' ');
        if (!errors.length) {
            this.send();
        }
    }

    private send() {
        this.saving = true;
        this.http.put<any>(environment.api + 'lockout-settings', Object.assign({}, this.form, {
            current_pin: this.currentPin,
            new_pin: this.newPin,
            new_pin_confirmation: this.confirmPin,
            remove_pin: this.removePin,
        })).subscribe(
            res => {
                this.saving = false;
                this.asking = false;
                this.hasPin = res.has_pin;
                this.saved = Object.assign({}, this.form);
                this.newPin = this.currentPin = this.confirmPin = '';
                this.removePin = false;
                this.message = 'Saved';
            },
            err => {
                this.saving = false;
                const text = typeof err === 'string' ? err : 'The lockout settings could not be saved.';
                if (this.asking) {
                    this.dialogError = text;
                } else {
                    this.pinError = text;
                }
            }
        );
    }
}
